import { Color } from '@nect/ui/theme/color';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { IconSpecialNectFill } from './auto/special-nect-fill';

export interface IIconWrapperProps {
    color?: Color;
    secondaryColor?: Color;
    size?: number;
    flipVertically?: boolean;
    onClick?: React.MouseEventHandler;
    onKeyUp?: React.KeyboardEventHandler;

    /**
    Inline CSS style
    */
    style?: React.CSSProperties;

    /**
    Class Name mainly use to extend with styled component
    */
    className?: string;

    /**
     * WAI-ARIA Role
     */
    role?: string;

    /**
     * Aria label
     */
    ariaLabel?: string;

    /**
     * tabindex attr, controls if it's focusable
     */
    tabIndex?: number;
}

export const IconWrapper = (
    BaseComponent: (
        upperProps: React.SVGProps<SVGSVGElement> & {
            secondaryColor?: string;
        },
    ) => React.ReactElement,
) =>
    function InnerIconWapper({
        size,
        color,
        secondaryColor,
        flipVertically,
        onClick,
        onKeyUp,
        style,
        className,
        role,
        ariaLabel,
        tabIndex,
    }: IIconWrapperProps) {
        const theme = useContext(ThemeContext);
        return (
            <BaseComponent
                className={`icon ${className}`}
                onClick={onClick}
                onKeyUp={onKeyUp}
                role={role}
                aria-label={ariaLabel}
                tabIndex={tabIndex}
                secondaryColor={theme?.color[secondaryColor ?? Color.grey400]}
                style={{
                    fontSize: size ?? 24,
                    width: size ?? 24,
                    height: size ?? 24,
                    color: theme?.color[color ?? Color.grey700],
                    ...(flipVertically ? { transform: 'rotate(-180deg)' } : {}),
                    ...style,
                }}
            />
        );
    };

export type IconType = typeof IconSpecialNectFill;
